import {tokenAndRoute} from "../utils/tokenAndRoute";
import {loaderMixin} from "../utils/loaderMixin";
import {mapState, mapGetters, mapMutations, mapActions} from "vuex";
import projectInfo from '../../components/Pages/Project/projectInfo'
import projectTree from '../../components/Pages/Project/projectTree/projectTree'
import projectsNavigator from '../../components/Pages/Projects/projectsNavigator'
import {pageSettings} from "../utils/pageSettings";

export const projectPageMixin = {
  mixins: [tokenAndRoute, loaderMixin, pageSettings],
  components: {
    projectInfo,
    projectTree,
    projectsNavigator
  },
  computed: {
    ...mapState({
      navigatorOpen: state => state.openProjectsNavigator,
      activeZoom: state => state.projects.activeZoom,
      projectMother: state => state.projects.singleProject,
      allProjects: state => state.projects.allProjects,
      isItemProjects: state => state.projects.isItemProjects,
    }),
    ...mapGetters({
      project: 'projects/projectsTree'
    })
  },
  methods: {
    ...mapActions({
      getProject: 'projects/getProject',
      getProjectItem: 'projects/getProjectItem',
      getOwnedRoles: 'roles/getOwnedRoles',
      getOwned: 'things/getDevices',
    }),
    ...mapMutations({
      setIsProjectItem: 'projects/SET_IS_PROJECT_ITEM',
      setActiveZoom: 'projects/SET_ACTIVE_ZOOM'
    }),
    beforeCreate() {
      this.checkFullScreen();
    },
    checkFullScreen() {
      if (!!document.fullscreenElement) {
        this.setActiveZoom(true)
      };
    }
  }
}
